import EventsIcon from "@src/assets/icons/SidebarIcons/EventsIcon";
import ReportsIcon from "@src/assets/icons/SidebarIcons/ReportsIcon";
import LinkIcon from "@src/assets/icons/SidebarIcons/LinkIcon";
import AliasIcon from "@src/assets/icons/SidebarIcons/AliasIcon";
import AiConfidenceIcon from "@src/assets/icons/SidebarIcons/AiConfidenceIcon";
import { paths } from "@src/routes/paths";

export interface IconActiveProps {
	isActive: boolean;
}

export interface Item {
	label: string;
	icon: React.FC<IconActiveProps>;
	navigateTo?: string;
}

export const Items: Array<Item> = [
	{
		label: "Events",
		icon: EventsIcon,
		navigateTo: paths.home,
	},
	{
		label: "Venues/Headliners",
		icon: ReportsIcon,
		navigateTo: paths.reports,
	},
	{
		label: "PO Mapping",
		icon: LinkIcon,
		navigateTo: paths.poMapping,
	},
	{
		label: "Alias Management",
		icon: AliasIcon,
		navigateTo: paths.venueAliases,
	},
	{
		label: "AI Confidence",
		icon: AiConfidenceIcon,
		navigateTo: paths.aiConfidence,
	},
];
